/* eslint-disable react/jsx-indent */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Prompt } from 'react-router-dom';

import { Card, CardActionArea, CardActions } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Location } from 'history';

import PageTitle from '~/components/PageTitle';
import SolicitationCard from '~/components/SolicitationCard';
import { useAuth } from '~/hooks/auth';
import { useNavigation } from '~/hooks/Navigation';
import history from '~/services/history';
import { IState } from '~/store';
import {
  getAvailableAndFavoriteProcessesRequest,
  getProcessesRequest,
} from '~/store/modules/processes/actions';
import { IProcess } from '~/store/modules/processes/types';
import { urls } from '~/types/constants';

import useStyles, { Container, CardContainer, ContainerTitle } from './styles';

const Processes = () => {
  const [limit] = useState<number>(5);
  // const [modalProcessFlow, setModalProcessFlow] = useState<boolean>(false);

  const { canNavigate, setLocation, setConfirmationModal } = useNavigation({
    customHeaderMessage: 'Os filtros serão descartados.',
  });

  const { user } = useAuth();

  const loading = useSelector((state: IState) => state.processes.loading);
  // const process = useSelector((state: IState) => state.processes.process);

  const availableProcesses = useSelector(
    (state: IState) => state.processes.availableProcesses,
  );

  const favoriteProcesses = useSelector(
    (state: IState) => state.processes.favoriteProcesses,
  );

  const dispatch = useDispatch();

  const classes = useStyles();

  const handleOpenProcessForm = useCallback((process: IProcess) => {
    if (process.suspended) {
      const confirmOptions = {
        okText: 'OK',
        onOk: () => {},
        disableCancel: true,
      };

      toastr.confirm(
        'Este processo está bloqueado temporariamente e não pode receber solicitações. Em caso de dúvidas contate seu gestor ou o suporte do Wedo.',
        confirmOptions,
      );
    } else {
      history.push(
        `${urls.PROCESSES_NEW}?key=${process.key}&tenantId=${process.tenantId}`,
      );
    }
  }, []);

  const handleCancel = (newLocation: Location): boolean => {
    if (canNavigate === true) {
      return true;
    }

    setLocation(newLocation);
    setConfirmationModal(true);
    return false;
  };

  useEffect(() => {
    dispatch(getProcessesRequest());
    dispatch(getAvailableAndFavoriteProcessesRequest(user.personId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <Container>
      <PageTitle>Processos</PageTitle>

      {favoriteProcesses !== undefined &&
        favoriteProcesses?.length !== 0 &&
        (!loading ? (
          <>
            <ContainerTitle>
              Favoritos ({favoriteProcesses?.length})
            </ContainerTitle>
            <CardContainer>
              {favoriteProcesses?.map((favoriteProcess) => (
                <SolicitationCard
                  title={favoriteProcess.name}
                  processDefinitionKey={favoriteProcess.key}
                  favorite
                  isSuspended={favoriteProcess.suspended}
                  onClick={() => handleOpenProcessForm(favoriteProcess)}
                />
              ))}
            </CardContainer>
          </>
        ) : (
          Array.from(
            Array(limit).map((value, index) => (
              <Card key={`card-${index}`} className={classes.root}>
                <CardActions className={classes.top}>
                  <Skeleton
                    animation="wave"
                    width="160px"
                    height="20px"
                    style={{ marginLeft: '6px' }}
                  />
                  <Skeleton
                    animation="wave"
                    width="30px"
                    height="40px"
                    style={{ borderRadius: '50%' }}
                  />
                </CardActions>
                <CardActionArea>
                  <Skeleton
                    animation="wave"
                    variant="rect"
                    height={10}
                    width={100}
                    style={{ marginLeft: '20px' }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="rect"
                    height={26}
                    width={190}
                    style={{ marginLeft: '20px', marginTop: '20px' }}
                  />
                </CardActionArea>
              </Card>
            )),
          )
        ))}

      {availableProcesses?.length !== 0 &&
        (loading ? (
          <Skeleton
            animation="wave"
            width="200px"
            height="30px"
            style={{ marginLeft: '16px', marginBottom: '24px' }}
          />
        ) : (
          <ContainerTitle>
            Disponíveis ({availableProcesses?.length ?? 0})
          </ContainerTitle>
        ))}
      <CardContainer>
        {!loading
          ? availableProcesses?.length !== 0 &&
            availableProcesses?.map(
              (availableProcess) =>
                availableProcess.startableInTasklist && (
                  <SolicitationCard
                    onClick={() => handleOpenProcessForm(availableProcess)}
                    processDefinitionKey={availableProcess.key}
                    isSuspended={availableProcess.suspended}
                    title={availableProcess.name}
                  />
                ),
            )
          : Array.from(Array(limit)).map((value, index) => (
              <Card key={`card-${index}`} className={classes.root}>
                <CardActions className={classes.top}>
                  <Skeleton
                    animation="wave"
                    width="160px"
                    height="20px"
                    style={{ marginLeft: '6px' }}
                  />
                  <Skeleton
                    animation="wave"
                    width="30px"
                    height="40px"
                    style={{ borderRadius: '50%' }}
                  />
                </CardActions>
                <CardActionArea>
                  <Skeleton
                    animation="wave"
                    variant="rect"
                    height={10}
                    width={100}
                    style={{ marginLeft: '20px' }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="rect"
                    height={26}
                    width={190}
                    style={{ marginLeft: '20px', marginTop: '20px' }}
                  />
                </CardActionArea>
              </Card>
            ))}
      </CardContainer>
      {/* {modalProcessFlow && (
        <Modal
          title={`Fluxo do processo: ${process?.name}`}
          loading={loading}
          open={modalProcessFlow}
          modalState={(opened) => setModalProcessFlow(opened)}
          size="lg"
        >
          <Bpmn xml={process?.xml} />
        </Modal>
      )} */}
      <Prompt
        when={!canNavigate}
        message={(location) => handleCancel(location)}
      />
    </Container>
  );
};

export default Processes;
